import React, { useEffect } from 'react';
import { Swiper } from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

const StudentServices = () => {
  useEffect(() => {
    const initStudentServicesSwiper = () => {
      const swiperElement = document.querySelector('.student-services-swiper');
      if (swiperElement && !swiperElement.swiper) {
        new Swiper(swiperElement, {
          modules: [Pagination, Autoplay],
          loop: true,
          speed: 600,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          slidesPerView: 'auto',
          pagination: {
            el: '.student-services-swiper .swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 20
            }
          }
        });
      }
    };

    const swiperTimer = setTimeout(() => {
      initStudentServicesSwiper();
    }, 500);

    return () => {
      clearTimeout(swiperTimer);
    };
  }, []);

  return (
    <section id="student-service" className="student-service section light-background">
      <div className="container section-title" data-aos="fade-up">
        <h2>Comprehensive Student Care</h2>
        <p><span>Students </span> <span className="description-title">Services</span></p>
      </div>
      
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="swiper student-services-swiper">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <div className="student-member">
                <div className="student-img">
                  <img src="/assets/img/students-services-2.jpg" className="img-fluid" alt="Classrooms" />
                </div>
                <div className="student-info">
                  <h4>Classrooms</h4>
                  <p>The university offers ICT-enabled classrooms supported by Wi-Fi, LAN, and projector facilities for enhanced learning.</p>
                </div>
              </div>
            </div>

            <div className="swiper-slide">
              <div className="student-member">
                <div className="student-img">
                  <img src="/assets/img/students-services-1.jpg" className="img-fluid" alt="Computer Labs" />
                </div>
                <div className="student-info">
                  <h4>Computer Labs</h4>
                  <p>The university offers well-equipped computer systems exclusively for students.</p>
                </div>
              </div>
            </div>

            <div className="swiper-slide">
              <div className="student-member">
                <div className="student-img">
                  <img src="/assets/img/students-services-3.jpg" className="img-fluid" alt="Library" />
                </div>
                <div className="student-info">
                  <h4>Library</h4>
                  <p>Mewar University's library houses a rich collection of books and supplements learning with digital content access.</p>
                </div>
              </div>
            </div>

            <div className="swiper-slide">
              <div className="student-member">
                <div className="student-img">
                  <img src="/assets/img/students-services-4.jpg" className="img-fluid" alt="Laboratories & Workshops" />
                </div>
                <div className="student-info">
                  <h4>Laboratories & Workshops</h4>
                  <p>With modern labs and fully equipped workshops, Mewar University emphasizes practical, experience-based learning.</p>
                </div>
              </div>
            </div>

            <div className="swiper-slide">
              <div className="student-member">
                <div className="student-img">
                  <img src="/assets/img/students-services-5.jpg" className="img-fluid" alt="Hostel" />
                </div>
                <div className="student-info">
                  <h4>Hostel</h4>
                  <p>The university offers well-designed hostels with modern amenities, ensuring separate accommodation for boys and girls.</p>
                </div>
              </div>
            </div>

            <div className="swiper-slide">
              <div className="student-member">
                <div className="student-img">
                  <img src="/assets/img/students-services-6.jpg" className="img-fluid" alt="Indoor" />
                </div>
                <div className="student-info">
                  <h4>Indoor</h4>
                  <p>At Mewar University, students are motivated to explore their talents through extracurriculars like music and dance.</p>
                </div>
              </div>
            </div>

            <div className="swiper-slide">
              <div className="student-member">
                <div className="student-img">
                  <img src="/assets/img/students-services-7.jpg" className="img-fluid" alt="Outdoor" />
                </div>
                <div className="student-info">
                  <h4>Outdoor</h4>
                  <p>At Mewar University, students enjoy open spaces dedicated to Cricket, Football, Basketball, Volleyball, and Athletics.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </section>
  );
};

export default StudentServices;
